import type { FaireProductEntity } from "../../entity_types/product";

export const p_k8u4baa3p7: FaireProductEntity = {
  token: "p_k8u4baa3p7",
  type: "product",
  name: "Rhinestone Bow Keychain Bag Charm",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/8d76678a97a6dd83c14ab517b55b6c1b8f0cd790898ea7ad0954b7555876e678.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2dc6a652eb61f24428fb2252b2677387486a3e1c1ffef651e372708109ae6179.jpeg",
    "https://cdn.faire.com/fastly/75171a52b9f30387e18e34a22f920fe815dc9900faea5d46370122c5bca113f4.jpeg",
    "https://cdn.faire.com/fastly/a58a69f65fbf1adc035987af36fdfd867bbb838d9afffb3a9ee9c5db6d00d876.jpeg",
    "https://cdn.faire.com/fastly/4de29b6e564b61ff0f92f7923d1dd382431ce3692c00288c80924898d72f12f4.jpeg",
    "https://cdn.faire.com/fastly/063d46ca5a1ce459d025f8915bd333f512b1073daed6aca638655377cf1134bf.jpeg",
    "https://cdn.faire.com/fastly/149826ef417846e169f8e7c459b3eae2c1cce31b16b0298111a16d3a7e26452b.jpeg",
    "https://cdn.faire.com/fastly/dde1f40f488502c0ae6c43417f037e2e62cb9ccd6438d226c487cfd4b434f131.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "bow size: 5.3*5.4cm\nThis sparkly bow keychain bag charm features an elegant bow silhouette fully embellished with rhinestones for a glamorous, eye-catching look. It adds a playful yet stylish accent to handbags, backpacks, or keys.\n\nDesigned with a soft strap and sturdy keyring, this bow charm is easy to attach and comfortable to carry. Available in multiple colors, it’s a perfect giftable accessory for boutiques, gift shops, and impulse-buy displays.",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:45.451Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
